import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    types: []
  },
  mutations: {
    UPDATE_USERNAME(state, data) {
      state.username = data
    },
    UPDATE_TYPES(state, data) {
      state.types = data
    }
  },
  actions: {
    updateUsername({ commit }, data) {
      commit('UPDATE_USERNAME', data)
    },
    updateTypes({ commit }, data) {
      commit('UPDATE_TYPES', data)
    }
  },
})
